/* Chronaq global helpers (moved out of snippets/cq-global.liquid so browsers cache it). */
(function () {
    if (window.__cqGlobal) return;
    window.__cqGlobal = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cq-prev], [data-cq-next]');
      if (btn) {
        var rail = btn.parentElement.querySelector('[data-cq-rail]');
        if (!rail) return;
        var card = rail.firstElementChild;
        var step = card ? card.getBoundingClientRect().width + 10 : rail.clientWidth * 0.8;
        rail.scrollBy({ left: btn.hasAttribute('data-cq-next') ? step : -step, behavior: 'smooth' });
        return;
      }
      var add = e.target.closest('[data-cq-add]');
      if (add) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && window.theme && theme.settings && theme.settings.cartType === 'drawer') {
          e.preventDefault();
          if (add.classList.contains('is-loading')) return;
          add.classList.add('is-loading');
          document.dispatchEvent(new CustomEvent('theme:cart:add', { detail: { button: add }, bubbles: true }));
          setTimeout(function () {
            add.classList.remove('is-loading');
            add.classList.add('is-added');
            setTimeout(function () { add.classList.remove('is-added'); }, 1800);
          }, 900);
        }
        return;
      }
      var tab = e.target.closest('[data-cq-tab]');
      if (tab) {
        var root = tab.closest('.cq-wr');
        var idx = tab.getAttribute('data-cq-tab');
        root.querySelectorAll('[data-cq-tab]').forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-cq-panel]').forEach(function (p) {
          var on = p.getAttribute('data-cq-panel') === idx;
          p.classList.toggle('is-active', on);
          if (on) { var r = p.querySelector('[data-cq-rail]'); if (r) r.scrollLeft = 0; }
        });
      }
    });

    function initVideos() {
      var vids = document.querySelectorAll('.cq-cm__media video');
      if (!vids.length) return;
      // Community videos: preview image first, then the light 480p stream (HLS) only when the card is on screen.
      var ua = navigator.userAgent;
      var apple = /iP(hone|ad|od)/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) || (/Safari\//.test(ua) && !/Chrome|Chromium|CriOS|Android|Edg|OPR|FxiOS/.test(ua));
      var HLSJS = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.20/dist/hls.light.min.js';
      function hlsLib(cb) {
        if (window.Hls || window.__cqNoHls) return cb();
        if (hlsLib.q) { hlsLib.q.push(cb); return; }
        hlsLib.q = [cb];
        var s = document.createElement('script');
        s.src = HLSJS; s.async = true;
        var fin = function () { var q = hlsLib.q || []; hlsLib.q = null; q.forEach(function (f) { f(); }); };
        s.onload = fin;
        s.onerror = function () { window.__cqNoHls = true; fin(); };
        document.head.appendChild(s);
      }
      function poster(v) { var p = v.getAttribute('data-cq-poster'); if (p && !v.getAttribute('poster')) v.setAttribute('poster', p); }
      function source(v, cb) {
        if (v.__cqSrc) { if (cb) cb(); return; }
        v.__cqSrc = 1;
        var hls = v.getAttribute('data-hls'), mp4 = v.getAttribute('data-mp4');
        var useMp4 = function () { if (mp4) { v.preload = 'auto'; v.src = mp4; } if (cb) cb(); };
        if (hls && apple) { v.preload = 'auto'; v.src = hls; if (cb) cb(); return; }
        if (!hls) return useMp4();
        hlsLib(function () {
          if (!window.Hls || !window.Hls.isSupported()) return useMp4();
          var h = new window.Hls({ startLevel: 0, capLevelToPlayerSize: true, maxBufferLength: 10, maxMaxBufferLength: 20 });
          h.on(window.Hls.Events.ERROR, function (e, d) {
            if (!d || !d.fatal) return;
            try { h.destroy(); } catch (x) {}
            v.__cqSrc = 0; v.removeAttribute('data-hls');
            source(v, function () { if (v.__cqWant) v.play().catch(function () {}); });
          });
          h.loadSource(hls);
          h.attachMedia(v);
          if (cb) cb();
        });
      }
      function play(v) {
        v.__cqWant = true;
        poster(v);
        source(v, function () { if (v.__cqWant) v.play().catch(function () {}); });
        var it = v.closest('.cq-cm__item'), nx = it && it.nextElementSibling, nv = nx && nx.querySelector('video');
        if (nv) { poster(nv); source(nv); }
      }
      function stop(v) { v.__cqWant = false; if (!v.paused) v.pause(); }
      vids.forEach(function (v) {
        v.muted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.removeAttribute('controls');
      });
      if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
      var near = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          vids.forEach(poster);
          if (!apple) hlsLib(function () {});
          near.disconnect();
        });
      }, { rootMargin: '800px 0px' });
      near.observe(vids[0].closest('.cq-cm') || vids[0]);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) play(en.target); else stop(en.target); });
      }, { threshold: 0.4 });
      vids.forEach(function (v) { io.observe(v); });
    }
    function footer() {
      var desktop = window.matchMedia('(min-width: 768px)').matches;
      document.querySelectorAll('.cq-ft__col').forEach(function (d) { if (desktop) d.setAttribute('open', ''); });
      if (!desktop) document.querySelectorAll('.footer__block--menu[open]').forEach(function (d) { d.removeAttribute('open'); });
    }

    function trustLabels() {
      var map = {
        '15DAYFREERETURNS': ['15-day returns', 'No questions asked'],
        'FREEDELIVERY': ['Free delivery', 'On orders over $50'],
        'CASHONDELIVERYLEBANONONLY': ['Cash on delivery', 'Lebanon only'],
        '1YEARWARRANTY': ['1-year warranty', 'On every watch']
      };
      document.querySelectorAll('.badges-row .badge__label').forEach(function (el) {
        if (el.querySelector('.cq-badge__sub')) return;
        var m = map[el.textContent.toUpperCase().replace(/[^A-Z0-9]/g, '')];
        if (!m) return;
        el.textContent = m[0];
        var sub = document.createElement('span');
        sub.className = 'cq-badge__sub';
        sub.textContent = m[1];
        el.appendChild(sub);
      });
    }

    function money(s) {
      s = (s || '').trim();
      var m = s.match(/^([^\d]*)([\d.,\s]+)(.*)$/);
      if (!m) return null;
      var num = m[2].replace(/\s/g, '');
      var dec = /[.,]\d{2}$/.test(num);
      var v = parseInt(num.replace(/[^\d]/g, ''), 10);
      if (isNaN(v)) return null;
      return { v: dec ? v : v * 100, pre: m[1], suf: m[3], dec: dec, sep: dec ? num.charAt(num.length - 3) : '.' };
    }

    function fmt(c, r) {
      var s = String(Math.floor(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, r.sep === ',' ? '.' : ',');
      if (r.dec) { var x = c % 100; s += r.sep + (x < 10 ? '0' + x : x); }
      return r.pre + s + r.suf;
    }

    // Bundle picker: show "You save" on the Buy 1 option too (the app only shows it on Buy 2 / Buy 3)
    function kachingSave() {
      document.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
        var left = bar.querySelector('.kaching-bundles__bar-content-left');
        if (!left) return;
        var mine = left.querySelector('.cq-kb-save');
        var native = left.querySelector('.kaching-bundles__bar-subtitle:not(.cq-kb-save)');
        if (native) { if (mine) mine.remove(); return; }
        var pe = bar.querySelector('.kaching-bundles__bar-price');
        var fe = bar.querySelector('.kaching-bundles__bar-full-price');
        var p = pe && money(pe.textContent);
        var f = fe && money(fe.textContent);
        if (!p || !f || f.v <= p.v) { if (mine) mine.remove(); return; }
        var txt = 'You save ' + fmt(f.v - p.v, p);
        if (!mine) {
          mine = document.createElement('div');
          mine.className = 'kaching-bundles__bar-subtitle cq-kb-save';
          var first = left.querySelector('.kaching-bundles__bar-first-line');
          if (first) first.insertAdjacentElement('afterend', mine); else left.appendChild(mine);
        }
        if (mine.textContent !== txt) mine.textContent = txt;
      });
    }

    var kTimer, kTries = 0;
    function kachingWatch() {
      var host = document.querySelector('kaching-bundle');
      if (host && !host.__cqObs) {
        host.__cqObs = true;
        new MutationObserver(function () { clearTimeout(kTimer); kTimer = setTimeout(kachingSave, 60); })
          .observe(host, { childList: true, subtree: true, characterData: true });
      }
      kachingSave();
      if (!host && kTries++ < 25) setTimeout(kachingWatch, 400);
    }

    // Bundle "Choose" picker: it sits under the Buy 1 / 2 / 3 cards, so reserve its height and nothing overlaps it
    var pickRaf = 0;
    function pickFit() {
      pickRaf = 0;
      document.querySelectorAll('kaching-bundle').forEach(function (h) {
        var p = h.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-collection-products');
        var n = p ? p.querySelectorAll('.kaching-bundles__collection-product').length : 0;
        h.style.setProperty('--cq-pick-h', (n > 1 ? Math.ceil(p.getBoundingClientRect().height) + 10 : 0) + 'px');
      });
    }
    function pickQueue() { if (!pickRaf) pickRaf = requestAnimationFrame(pickFit); }
    function kachingPicker() {
      var hosts = document.querySelectorAll('kaching-bundle');
      if (!hosts.length) return;
      hosts.forEach(function (h) {
        if (h.__cqPick) return;
        h.__cqPick = true;
        new MutationObserver(pickQueue).observe(h, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        h.addEventListener('load', pickQueue, true);
      });
      if (!window.__cqPickResize) { window.__cqPickResize = true; window.addEventListener('resize', pickQueue); }
      pickQueue();
    }

    // (Removed 2026-11-02: annTone() toggled 'cq-ann-dark' from a '.cq-hero' section that is disabled on the
    // homepage, and no CSS used that class. The announcement bar now has a solid background instead;
    // see the last block of chronaq-refresh.css.)

    // Cart upsell row: let a mouse wheel scroll it sideways.
    // Bound on each rail, not on the whole document: a non-passive wheel listener on the document makes the
    // browser wait for JavaScript before every mouse-wheel scroll anywhere on the page.
    function railWheel(e) {
      var r = e.currentTarget;
      if (r.scrollWidth <= r.clientWidth) return;
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) { r.scrollLeft += e.deltaY; e.preventDefault(); }
    }

    // Cart upsell row: hide the arrows when there is nothing to scroll, fade them at the ends
    function railState(r) {
      if (!r.__cqWheel) { r.__cqWheel = true; r.addEventListener('wheel', railWheel, { passive: false }); }
      var wrap = r.closest('.cq-up-rail');
      if (!wrap) return;
      var max = r.scrollWidth - r.clientWidth;
      wrap.classList.toggle('is-static', max <= 2);
      wrap.classList.toggle('at-start', r.scrollLeft <= 2);
      wrap.classList.toggle('at-end', r.scrollLeft >= max - 2);
    }
    function railsUpdate() { document.querySelectorAll('.cq-up-rail [data-cq-rail]').forEach(railState); }
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('.cq-up-rail [data-cq-rail]')) railState(t);
    }, true);
    var rTimer;
    function watchCart() {
      var cd = document.querySelector('cart-drawer');
      if (!cd || cd.__cqObs) return;
      cd.__cqObs = true;
      new MutationObserver(function () { clearTimeout(rTimer); rTimer = setTimeout(railsUpdate, 150); })
        .observe(cd, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    // Kaching free gifts: if a gift line is no longer free (the customer lowered the watch quantity or removed the watch),
    // take the gift out of the cart so nobody pays for a 'gift' by accident.
    var giftBusy = false, giftTimer;
    function giftCheck() {
      if (giftBusy) return;
      giftBusy = true;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var upd = {}, n = 0;
          (cart.items || []).forEach(function (it) {
            var p = it.properties && it.properties.__kaching_bundles;
            if (!p) return;
            try { p = JSON.parse(p); } catch (e) { return; }
            if (p && p.gift && it.final_line_price > 0) { upd[it.key] = 0; n++; }
          });
          if (!n) return;
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Cq-Gift-Check': '1' }, body: JSON.stringify({ updates: upd }) })
            .then(function () { document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true })); });
        })
        .catch(function () {})
        .then(function () { giftBusy = false; });
    }
    function giftWatch() {
      if (window.__cqGiftWatch || !window.fetch) return;
      window.__cqGiftWatch = true;
      var nativeFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var res = nativeFetch.apply(this, arguments);
        var own = init && init.headers && init.headers['X-Cq-Gift-Check'];
        if (!own && /\/cart\/(change|update|add)/.test(url)) {
          res.then(function () { clearTimeout(giftTimer); giftTimer = setTimeout(giftCheck, 700); if (window.__cqSwap) setTimeout(swapCheck, 500); }, function () {});
        }
        return res;
      };
    }

    // Black Friday gift tiers (Resilia-style): Buy 1 / 2 / 3 rows with product pictures, the chosen row lists its free gifts,
    // and a "Gifts unlocked" panel shows what the chosen tier unlocks (locked gifts are blurred). Kaching still prices the bundle,
    // applies the discount and adds the gifts to the cart; this only changes how the deal is presented.
    // (Kaching deal swap and cq-tiers class run early, inline in snippets/cq-global.liquid)
    
    var tierCat = null;
    var TIER_ICON = {
      truck: '<svg class="cq-truck" viewBox="0 0 64 40" aria-hidden="true"><rect x="19" y="4" width="43" height="24" rx="3" fill="#141414"/><path d="M3 15l6-7h10v20H3z" fill="#141414"/><path d="M7 15l3.4-4H16v4z" fill="#fff"/><rect x="1" y="26" width="62" height="3.5" rx="1.75" fill="#141414"/><circle cx="11" cy="31" r="5" fill="#141414" stroke="#fff" stroke-width="2"/><circle cx="49" cy="31" r="5" fill="#141414" stroke="#fff" stroke-width="2"/><text x="40.5" y="15.5" text-anchor="middle" font-size="9" font-weight="800" font-style="italic" fill="#fff" font-family="Arial, sans-serif">FREE</text><text x="40.5" y="23" text-anchor="middle" font-size="5.2" font-weight="700" fill="#fff" font-family="Arial, sans-serif" letter-spacing=".3">SHIPPING</text></svg>',
      box: '<svg class="cq-truck cq-giftbox" viewBox="0 0 64 40" aria-hidden="true"><path d="M32 8c-2.6-5.2-10-6.4-10-2.3 0 2.6 5.2 2.3 10 2.3zM32 8c2.6-5.2 10-6.4 10-2.3 0 2.6-5.2 2.3-10 2.3z" fill="#141414" stroke="#fff" stroke-width="1.4"/><rect x="6" y="8" width="52" height="7" rx="2" fill="#141414"/><rect x="29.5" y="8" width="5" height="7" fill="#fff"/><rect x="9" y="16" width="46" height="22" rx="2.5" fill="#141414"/><text x="32" y="26.5" text-anchor="middle" font-size="9" font-weight="800" font-style="italic" fill="#fff" font-family="Arial, sans-serif">FREE</text><text x="32" y="34" text-anchor="middle" font-size="5.2" font-weight="700" fill="#fff" font-family="Arial, sans-serif" letter-spacing=".3">PACKAGING</text></svg>',
      lock: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M7 10V8a5 5 0 0 1 10 0v2h.5c.8 0 1.5.7 1.5 1.5v8c0 .8-.7 1.5-1.5 1.5h-11c-.8 0-1.5-.7-1.5-1.5v-8c0-.8.7-1.5 1.5-1.5H7zm2 0h6V8a3 3 0 0 0-6 0v2zm3 3.6a1.6 1.6 0 0 0-.8 3V18h1.6v-1.4a1.6 1.6 0 0 0-.8-3z"/></svg>',
      clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>'
    };
    function tierEsc(s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
    }
    function tierGid(g) { return String(g || '').split('/').pop(); }
    function tierCatalog() {
      if (tierCat) return tierCat;
      var el = document.getElementById('cq-gift-catalog');
      try { tierCat = el ? JSON.parse(el.textContent) : {}; } catch (e) { tierCat = {}; }
      return tierCat;
    }
    function tierDeal(blk) {
      var id = blk.getAttribute('deal-block-id'), deal = null;
      if (!id) return null;
      document.querySelectorAll('script.kaching-bundles-deal-block-settings').forEach(function (s) {
        if (deal) return;
        try { var j = JSON.parse(s.textContent); if (j && (j.id === id || j.nanoId === id)) deal = j; } catch (e) {}
      });
      return deal;
    }
    function tierGifts(deal) {
      var cat = tierCatalog(), list = [], seen = {};
      (deal.dealBars || []).forEach(function (b, i) {
        (b.freeGifts || []).forEach(function (g) {
          var ship = g.giftType === 'shipping', key = ship ? 'ship' : 'p' + tierGid(g.productGID);
          if (seen[key]) { seen[key].bars.push(i); return; }
          var c = cat[tierGid(g.productGID)] || {};
          seen[key] = { ship: ship, sub: c.s || '', z: c.z || 1, name: String(g.text || c.t || 'Free gift').replace(/^\+\s*/, ''), img: c.i || '', val: Math.max(c.c || 0, c.p || 0), first: i, bars: [i] };
          list.push(seen[key]);
        });
        (b.multipleGiftsSelectors || []).forEach(function (m) {
          var key = 'm' + m.id;
          if (seen[key]) { seen[key].bars.push(i); return; }
          var c = cat[tierGid(((m.products || [])[0] || {}).id)] || {};
          seen[key] = { sel: true, sub: c.s || '', z: c.z || 1, name: 'FREE ' + String(c.t || 'gift').split(/\s[–—-]\s/)[0], img: c.i || '', val: Math.max(c.c || 0, c.p || 0), first: i, bars: [i] };
          list.push(seen[key]);
        });
      });
      // Free gift packaging comes with every order: shown in the same block as free shipping.
      if (list.length) {
        var sh = null;
        list.forEach(function (g) { if (g.ship && !sh) sh = g; });
        if (sh) { sh.pack = true; sh.name = 'FREE Shipping & Gift Packaging'; }
        else list.unshift({ pack: true, sub: '', z: 1, name: 'FREE Gift Packaging', img: '', val: 0, first: 0, bars: (deal.dealBars || []).map(function (b, i) { return i; }) });
      }
      return list;
    }
    function tierEta() {
      function add(n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; }
      var o = { month: 'short', day: 'numeric' };
      return 'Order now, get it between <b>' + add(3).toLocaleDateString('en-US', o) + '</b> and <b>' + add(5).toLocaleDateString('en-US', o) + '</b>';
    }
    function tierStem(u) {
      return String(u || '').split('?')[0].split('/').pop().replace(/\.\w+$/, '').replace(/_\d+x\d*$/, '');
    }
    function tierChosen(host) {
      var ph = host.querySelector('.kaching-bundles__bar--selected .kaching-bundles__multiple-gifts-selector__photo');
      if (!ph) return null;
      var cat = tierCatalog(), src = ph.getAttribute('src'), st = tierStem(src), name = '';
      for (var id in cat) {
        if (cat[id] && cat[id].i && tierStem(cat[id].i) === st) { name = String(cat[id].t || '').split(/\s[–—-]\s/)[1] || ''; break; }
      }
      return { src: src, name: name };
    }
    function tierPanel(host, gifts, sel, bars, deal, ref, chosen) {
      var p = host.nextElementSibling;
      if (p && !p.classList.contains('cq-unlock')) p = null;
      var eta = p && p.nextElementSibling;
      if (eta && eta.classList.contains('cq-eta')) eta.remove();
      if (!gifts) { if (p) p.remove(); return; }
      if (!p) {
        var h = '<span class="cq-unlock__label">Gifts unlocked</span><div class="cq-unlock__slots">';
        gifts.forEach(function (g, i) {
          if (i) h += '<span class="cq-unlock__plus" aria-hidden="true">+</span>';
          h += '<button type="button" class="cq-unlock__slot' + (g.pack && g.ship ? ' cq-unlock__slot--duo' : '') + '" data-first="' + g.first + '"' + (g.sel ? ' data-sel="1"' : '') + '>' +
            '<span class="cq-unlock__img">' + (g.pack && g.ship ? TIER_ICON.truck + TIER_ICON.box : g.pack ? TIER_ICON.box : g.ship || !g.img ? TIER_ICON.truck : '<img src="' + tierEsc(g.img) + '" alt="" loading="lazy" style="--z:' + (g.z || 1) + '">') +
            '<span class="cq-unlock__lock">' + TIER_ICON.lock + '</span></span>' +
            '<span class="cq-unlock__locked">Locked</span>' +
            '<span class="cq-unlock__was">' + (g.val && ref ? fmt(g.val, ref) : '') + '</span>' +
            '<span class="cq-unlock__name">' + tierEsc(g.name) + '</span>' +
            '<span class="cq-unlock__hint"></span></button>';
        });
        p = document.createElement('div');
        p.className = 'cq-unlock';
        p.innerHTML = h + '</div>';
        p.addEventListener('click', function (e) {
          var b = e.target.closest('.cq-unlock__slot');
          if (!b) return;
          if (b.classList.contains('is-locked')) {
            var bar = host.querySelectorAll('.kaching-bundles__bar')[+b.getAttribute('data-first')];
            var lab = bar && bar.querySelector('label');
            if (lab) lab.click();
          } else if (b.hasAttribute('data-sel')) {
            var ov = host.querySelector('.kaching-bundles__bar--selected .kaching-bundles__multiple-gifts-selector__clickable-overlay');
            if (ov) ov.click();
          }
        });
        host.insertAdjacentElement('afterend', p);
        if (xmasOn()) p.insertAdjacentHTML('beforeend', xmasHtml('cq-xmas cq-xmas--panel'));
      }
      p.querySelectorAll('.cq-unlock__slot').forEach(function (s, i) {
        var g = gifts[i];
        if (!g) return;
        var on = g.bars.indexOf(sel) > -1, pick = !!(on && g.sel);
        s.classList.toggle('is-on', on);
        s.classList.toggle('is-locked', !on);
        var hint = pick ? (chosen ? 'Change colour' : 'Pick Gold or Silver') : '';
        var he = s.querySelector('.cq-unlock__hint');
        if (he && he.textContent !== hint) he.textContent = hint;
        s.setAttribute('aria-label', g.name + (on ? (pick ? ', choose your colour' : ', unlocked') : ', locked'));
        if (g.sel) {
          var im = s.querySelector('.cq-unlock__img img'), src = chosen ? chosen.src : g.img;
          if (im && src && im.getAttribute('src') !== src) im.setAttribute('src', src);
        }
      });
    }
    function tierPrice(host, bar) {
      var pe = bar && bar.querySelector('.kaching-bundles__bar-price'), fe = bar && bar.querySelector('.kaching-bundles__bar-full-price');
      var p = pe && money(pe.textContent), f = fe && money(fe.textContent);
      if (!p) return;
      var off = f && f.v > p.v;
      var scope = host.closest('.product__wrapper') || document;
      var wrap = scope.querySelector('.product__price__wrap');
      if (wrap) {
        var sale = wrap.querySelector('.price__sale .price-item--sale'), reg = wrap.querySelector('.price__sale s.price-item--regular');
        var ps = fmt(p.v, p);
        if (sale && sale.textContent.trim() !== ps) sale.textContent = ps;
        if (reg && off && reg.textContent.trim() !== fmt(f.v, f)) reg.textContent = fmt(f.v, f);
        var badge = wrap.querySelector('.cq-bf-save');
        if (!badge) { badge = document.createElement('span'); badge.className = 'cq-bf-save'; (wrap.querySelector('.price__container') || wrap).appendChild(badge); }
        var bt = off ? 'Black Friday · Save ' + fmt(f.v - p.v, p) : 'Black Friday';
        if (badge.textContent !== bt) badge.textContent = bt;
      }
      var bp = scope.querySelector('[data-add-to-cart] .btn__price');
      if (bp) {
        var was = bp.parentNode.querySelector('.cq-btn-was');
        if (!was) { was = document.createElement('s'); was.className = 'cq-btn-was'; bp.insertAdjacentElement('afterend', was); }
        var wt = off ? fmt(f.v, f) : '';
        if (was.textContent !== wt) was.textContent = wt;
      }
    }
    function tierRender(host) {
      var blk = host.querySelector('kaching-bundles-block');
      var bars = host.querySelectorAll('.kaching-bundles__bar');
      if (!blk || !bars.length) return;
      var deal = host.__cqDeal;
      if (!deal || (deal.id !== blk.getAttribute('deal-block-id') && deal.nanoId !== blk.getAttribute('deal-block-id'))) {
        deal = host.__cqDeal = tierDeal(blk);
        host.__cqGifts = deal ? tierGifts(deal) : [];
      }
      var gifts = host.__cqGifts || [];
      if (!deal || !gifts.length) { host.classList.remove('cq-tiers'); tierPanel(host, null); return; }
      if (!host.classList.contains('cq-tiers')) host.classList.add('cq-tiers');
      if (!host.__cqTierClick) {
        host.__cqTierClick = true;
        host.addEventListener('click', function (e) {
          if (host.__cqBusy || !e.target.closest) return;
          var tile = e.target.closest('.kaching-bundles__bar--selected .kaching-bundles__collection-product');
          if (tile) {
            if (e.target.closest('.kaching-bundles__collection-product__choose-product-button, .kaching-bundles__collection-product__choose-product-image')) return;
            e.preventDefault();
            e.stopPropagation();
            var choose = tile.querySelector('.kaching-bundles__collection-product__choose-product-button');
            var rm = tile.querySelector('.kaching-bundles__collection-product__remove-button');
            if (choose) { choose.click(); return; }
            if (!rm) return;
            var idx = [].indexOf.call(tile.parentNode.children, tile);
            host.__cqBusy = true;
            rm.click();
            host.__cqBusy = false;
            setTimeout(function () {
              var t2 = host.querySelectorAll('.kaching-bundles__bar--selected .kaching-bundles__collection-product')[idx];
              var b2 = t2 && t2.querySelector('.kaching-bundles__collection-product__choose-product-button');
              if (b2) b2.click();
            }, 150);
            return;
          }
          var row = e.target.closest('.cq-ti__row--sel');
          if (!row) return;
          e.preventDefault();
          e.stopPropagation();
          var ov = host.querySelector('.kaching-bundles__bar--selected .kaching-bundles__multiple-gifts-selector__clickable-overlay');
          if (ov) ov.click();
        }, true);
      }
      var ps = document.querySelector('script.kaching-bundles-product[data-product-id="' + host.getAttribute('product-id') + '"]');
      var prod = host.__cqProd;
      if (!prod) { try { prod = host.__cqProd = JSON.parse(ps.textContent); } catch (e) { prod = {}; } }
      var ref = money((bars[0].querySelector('.kaching-bundles__bar-price') || {}).textContent || '');
      var chosen = tierChosen(host);
      var sel = 0;
      bars.forEach(function (bar, i) {
        if (bar.classList.contains('kaching-bundles__bar--selected')) sel = i;
        var q = (((deal.dealBars || [])[i]) || {}).quantity || 1;
        var main = bar.querySelector('.kaching-bundles__bar-main');
        var label = bar.querySelector('.kaching-bundles__bar-container');
        var wrap = bar.querySelector('.kaching-bundles__bar-wrapper');
        var gi = gifts.filter(function (g) { return !g.ship && !g.pack && g.bars.indexOf(i) > -1; });
        // A bar whose only gift is free shipping says so in its title (e.g. "Buy 1 + Free Shipping").
        var bt = bar.querySelector('.kaching-bundles__bar-title'), fg = (((deal.dealBars || [])[i]) || {}).freeGifts || [];
        if (bt && fg.length && fg.every(function (x) { return x.giftType === 'shipping'; }) && !/shipping/i.test(bt.textContent)) bt.textContent = bt.textContent.trim() + ' + Free Shipping & Gift Packaging';
        if (main) {
          var srcs = [];
          bar.querySelectorAll('.kaching-bundles__collection-product').forEach(function (tile) {
            var im = tile.querySelector('.kaching-bundles__collection-product__image');
            srcs.push((im && im.getAttribute('src')) || prod.image || '');
          });
          while (srcs.length < q) srcs.push(prod.image || '');
          srcs = srcs.slice(0, Math.max(q, 1));
          var gim = gi.filter(function (g) { return g.img; }).map(function (g) { return { s: g.sel && chosen ? chosen.src : g.img, z: g.z || 1 }; });
          var key = srcs.join('|') + '#' + gim.map(function (x) { return x.s; }).join('|');
          var t = main.querySelector('.cq-tt');
          if (!t) {
            t = document.createElement('span');
            t.className = 'cq-tt';
            t.setAttribute('aria-hidden', 'true');
            main.insertBefore(t, main.firstChild);
          }
          if (t.__cqKey !== key) {
            t.__cqKey = key;
            var h = '<span class="cq-tt__main">' + srcs.map(function (s) { return '<img src="' + tierEsc(s) + '" alt="" loading="lazy">'; }).join('') + '</span>';
            if (gim.length) h += '<span class="cq-tt__plus">+</span><span class="cq-tt__gifts">' + gim.map(function (x) { return '<span class="cq-tt__g"><img src="' + tierEsc(x.s) + '" alt="" loading="lazy" style="--z:' + x.z + '"></span>'; }).join('') + '</span>';
            t.innerHTML = h;
          }
        }
        if (label && wrap && gi.length && !label.querySelector('.cq-ti')) {
          var rows = '';
          gi.forEach(function (g) {
            rows += '<div class="cq-ti__row' + (g.sel ? ' cq-ti__row--sel' : '') + '"><span class="cq-ti__check"></span><span class="cq-ti__txt"><b>' + tierEsc(g.name) + (g.val && ref ? ' (' + fmt(g.val, ref) + ' Value)' : '') + '</b><small class="cq-ti__sub">' + tierEsc(g.sub) + '</small></span></div>';
          });
          var inc = document.createElement('div');
          inc.className = 'cq-ti';
          inc.innerHTML = rows;
          wrap.insertAdjacentElement('afterend', inc);
        }
        var ss = label && label.querySelector('.cq-ti__row--sel .cq-ti__sub');
        if (ss) {
          var st = chosen ? (chosen.name ? chosen.name + ' selected · Change' : 'Selected · Change') : 'Pick Gold or Silver';
          if (ss.textContent !== st) ss.textContent = st;
        }
      });
      if (chosen) host.querySelectorAll('.cq-tt__gifts img[data-sel]').forEach(function (im) { if (im.getAttribute('src') !== chosen.src) im.setAttribute('src', chosen.src); });
      tierPanel(host, gifts, sel, bars, deal, ref, chosen);
      tierPrice(host, bars[sel]);
    }
    function giftTiers() {
      document.querySelectorAll('kaching-bundle').forEach(function (host) {
        if (!host.__cqTierObs) {
          host.__cqTierObs = true;
          new MutationObserver(function () { clearTimeout(host.__cqTierT); host.__cqTierT = setTimeout(function () { tierRender(host); }, 40); })
            .observe(host, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'src'] });
        }
        tierRender(host);
      });
    }

    var CQ_PERK_GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="8.5" width="17" height="4" rx="1"/><path d="M5 12.5v8h14v-8M12 8.5v12M12 8.5S10.8 4 8.3 4.6C6.4 5 7 8.5 12 8.5zM12 8.5s1.2-4.5 3.7-3.9C17.6 5 17 8.5 12 8.5z"/></svg>';
    var CQ_PERK_STAR = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5l1.9 6.1 6.1 1.9-6.1 1.9L12 18.5l-1.9-6.1L4 10.5l6.1-1.9z"/><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z" opacity=".7"/></svg>';
    // Black Friday perks under the price on product cards (homepage rail + collection grids)
    function bfBadges() {
      var bf = window.cqBf;
      if (!bf || !bf.handles || Date.now() > bf.end) return;
      if (document.body.classList.contains('template-index')) return; // homepage: no perks under product cards
      document.querySelectorAll('.product-item .badge-box-container, .cq-wr__card .cq-wr__media').forEach(function (box) {
        if (box.__cqGift) return;
        box.__cqGift = true;
        var card = box.closest('.product-item, .cq-wr__card');
        var a = box.closest('a[href*="/products/"]') || (card && card.querySelector('a[href*="/products/"]'));
        var m = a && (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
        if (!m || !bf.handles[m[1]] || !card || card.querySelector('.cq-perks')) return;
        var price = card.querySelector('.cq-wr__price, .product-item__price__holder, .product-item__price');
        if (!price) return;
        price.insertAdjacentHTML('afterend', '<span class="cq-perks"><span class="cq-perks__l">' + CQ_PERK_GIFT + 'Free gifts</span><span class="cq-perks__l cq-perks__l--x">' + CQ_PERK_STAR + '+20% off at Christmas</span></span>');
      });
    }
    function bfBadgeWatch() {
      if (window.__cqBadgeObs || !window.MutationObserver) return;
      window.__cqBadgeObs = true;
      var bt;
      new MutationObserver(function () { clearTimeout(bt); bt = setTimeout(function () { bfBadges(); soldOutLast(); }, 250); }).observe(document.body, { childList: true, subtree: true });
    }

    // Product pages: the main add-to-cart button (Kaching prices it), a sticky buy bar for phones and a delivery promise.
    function mainBuyBtn() {
      return [].find.call(document.querySelectorAll('.product__submit button[name="add"]'), function (b) { return b.querySelector('.btn__price'); }) || null;
    }
    function stickyBuy() {
      var btn = mainBuyBtn();
      // Only where Kaching prices the product: the theme's own sticky cart bar keeps the single-watch price, so it is swapped for this one.
      if (!btn || !document.querySelector('kaching-bundle') || document.querySelector('.cq-sticky')) return;
      document.body.classList.add('cq-has-sticky');
      var titleEl = document.querySelector('.product__title, h1');
      var og = document.querySelector('meta[property="og:image"]');
      var bar = document.createElement('div');
      bar.className = 'cq-sticky';
      bar.innerHTML = (og && og.content ? '<img class="cq-sticky__img" alt="" src="' + og.content.replace(/^http:/, 'https:') + (og.content.indexOf('?') > -1 ? '&' : '?') + 'width=120">' : '') +
        '<div class="cq-sticky__info"><span class="cq-sticky__title"></span><span class="cq-sticky__price"></span></div>' +
        '<button type="button" class="cq-sticky__btn"></button>';
      bar.querySelector('.cq-sticky__title').textContent = titleEl ? titleEl.textContent.trim() : '';
      document.body.appendChild(bar);
      var sbtn = bar.querySelector('.cq-sticky__btn'), price = bar.querySelector('.cq-sticky__price');
      var sync = function () {
        var p = btn.querySelector('.btn__price'), was = btn.querySelector('.cq-btn-was');
        price.innerHTML = (p ? p.innerHTML : '') + (was && was.textContent ? ' <s>' + was.textContent + '</s>' : '');
        sbtn.disabled = !!btn.disabled;
        sbtn.textContent = btn.disabled ? 'Sold out' : 'Buy now';
      };
      sync();
      new MutationObserver(sync).observe(btn, { childList: true, subtree: true, characterData: true, attributes: true });
      var ticking = false;
      var check = function () {
        ticking = false;
        var br = btn.getBoundingClientRect(), vh = window.innerHeight, kb = document.querySelector('kaching-bundle');
        // Show as soon as the bundle choices are reached, hide while the real button is on screen.
        var reached = kb ? kb.getBoundingClientRect().top < vh * 0.85 : br.bottom < 0;
        var on = reached && !(br.top < vh && br.bottom > 0);
        bar.classList.toggle('is-on', on);
        document.body.classList.toggle('cq-sticky-on', on);
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      check();
      sbtn.addEventListener('click', function () {
        if (btn.disabled) return;
        btn.click();
        setTimeout(function () {
          var err = [].find.call(document.querySelectorAll('kaching-bundle [class*="error"], kaching-bundle [class*="alert"]'), function (x) { return x.offsetParent && x.textContent.trim(); });
          if (err) window.scrollTo({ top: err.getBoundingClientRect().top + window.scrollY - 150, behavior: 'smooth' });
        }, 600);
      });
    }
    function etaLine() {
      var btn = mainBuyBtn(), wrap = btn && btn.closest('.product__submit__buttons');
      if (!wrap || btn.disabled || document.querySelector('.cq-eta-line')) return;
      var bf = window.cqBf || {}, el = document.createElement('div');
      el.className = 'cq-eta-line';
      var icon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>';
      if (bf.country === 'LB') {
        // Shipping policy: standard delivery in Lebanon takes 3-5 working days (Mon-Fri counted here).
        var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Beirut' }));
        var addWork = function (d, n) { var x = new Date(d.getTime()); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; };
        var day = function (d) { return d.toLocaleDateString('en-GB', { weekday: 'short' }) + ' ' + d.getDate(); };
        var mon = function (d) { return d.toLocaleDateString('en-GB', { month: 'short' }); };
        var d1 = addWork(now, 3), d2 = addWork(now, 5);
        var range = day(d1) + (mon(d1) !== mon(d2) ? ' ' + mon(d1) : '') + ' – ' + day(d2) + ' ' + mon(d2);
        el.innerHTML = icon + '<span>Order today, usually delivered <b>' + range + '</b> · Cash on delivery</span>';
      } else {
        el.innerHTML = icon + '<span>Ships worldwide from Beirut</span>';
      }
      wrap.parentNode.insertBefore(el, wrap.nextSibling);
    }

    // Cart "add a 2nd watch" nudge (cart drawer): the link opens the watch with ?cq_tier=2&cq_swap=<line key>.
    // Pick Buy 2 here, and once the bundle is in the cart remove the single watch it replaces.
    var CQ_BF_ALL = ['beirut-jade', 'beirut-arabic', 'beirut-royal', 'beirut-silver', 'beirut-gold'];
    function swapInit() {
      if (!window.URLSearchParams) return;
      var q = new URLSearchParams(location.search), v = q.get('cq_swap');
      if (!v || !document.querySelector('kaching-bundle')) return;
      // The old line is found by variant + Kaching's add id (line keys change when discounts are re-applied). Kaching's
      // property is private (hidden from Liquid), so read its id from the cart now, before the bundle is added.
      window.__cqSwap = { v: v, kid: '' };
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var it = (cart.items || []).filter(function (x) { return String(x.variant_id) === String(v); })[0];
          if (!it || !window.__cqSwap) { window.__cqSwap = null; return; }
          var kb = it.properties && it.properties.__kaching_bundles;
          if (kb) { try { window.__cqSwap.kid = JSON.parse(kb).id || ''; } catch (e) {} if (!window.__cqSwap.kid) window.__cqSwap = null; }
        })
        .catch(function () {});
      var tries = 0;
      (function pick() {
        var host = document.querySelector('kaching-bundle.cq-tiers');
        var labs = host ? host.querySelectorAll('.kaching-bundles__bar-container') : [];
        if (labs.length < 2) { if (tries++ < 40) setTimeout(pick, 250); return; }
        var bars = host.querySelectorAll('.kaching-bundles__bar');
        if (q.get('cq_tier') === '2' && bars[1] && !bars[1].classList.contains('kaching-bundles__bar--selected')) labs[1].click();
        if (!document.querySelector('.cq-swap-note')) {
          var n = document.createElement('div');
          n.className = 'cq-swap-note';
          n.textContent = 'Pick your 2nd watch below. The single watch already in your cart will be swapped for this bundle.';
          host.parentNode.insertBefore(n, host);
        }
        setTimeout(function () { window.scrollTo({ top: host.getBoundingClientRect().top + window.scrollY - 170, behavior: 'smooth' }); }, 350);
      })();
      var btn = mainBuyBtn();
      if (btn) btn.addEventListener('click', function () { [1200, 2600, 4500].forEach(function (ms) { setTimeout(swapCheck, ms); }); }, true);
    }
    function swapCheck() {
      var sw = window.__cqSwap;
      if (!sw || window.__cqSwapBusy) return;
      window.__cqSwapBusy = true;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = cart.items || [], old = null;
          items.forEach(function (it) {
            if (old || String(it.variant_id) !== String(sw.v)) return;
            var kb = it.properties && it.properties.__kaching_bundles;
            if (sw.kid ? (kb && kb.indexOf('"id":"' + sw.kid + '"') > -1) : !kb) old = it;
          });
          if (!old) { window.__cqSwap = null; return; }
          var units = 0;
          items.forEach(function (it) {
            var kb = it.properties && it.properties.__kaching_bundles;
            if (it === old || !kb || CQ_BF_ALL.indexOf(it.handle) < 0) return;
            if (sw.kid && kb.indexOf('"id":"' + sw.kid + '"') > -1) return;
            units += it.quantity;
          });
          if (units < 2) return;
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Cq-Gift-Check': '1' }, body: JSON.stringify({ id: old.key, quantity: 0 }) })
            .then(function () {
              window.__cqSwap = null;
              var n = document.querySelector('.cq-swap-note');
              if (n) n.parentNode.removeChild(n);
              document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
            });
        })
        .catch(function () {})
        .then(function () { window.__cqSwapBusy = false; });
    }

    // The theme only refreshes parts of the cart drawer after an add, so copy the "add a 2nd watch" nudge (rendered by
    // sections/cart-drawer.liquid) from a fresh section render whenever the drawer content changes.
    var nudgeBusy = false, nudgeTimer;
    function nudgeSync() {
      var cd = document.querySelector('cart-drawer');
      var sec = cd && cd.closest('[id^="shopify-section-"]');
      if (!sec || nudgeBusy) return;
      nudgeBusy = true;
      var id = sec.id.replace('shopify-section-', '');
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + '?sections=' + encodeURIComponent(id), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var doc = new DOMParser().parseFromString((j && j[id]) || '', 'text/html');
          var fresh = doc.querySelector('.cq-nudge'), cur = cd.querySelector('.cq-nudge');
          if (!fresh) { if (cur) cur.parentNode.removeChild(cur); return; }
          if (cur && cur.outerHTML === fresh.outerHTML) return;
          var node = document.importNode(fresh, true);
          var anchor = cd.querySelector('.drawer__message.free-shipping');
          if (cur) cur.parentNode.replaceChild(node, cur);
          else if (anchor) anchor.parentNode.insertBefore(node, anchor.nextSibling);
        })
        .catch(function () {})
        .then(function () { nudgeBusy = false; });
    }
    function nudgeWatch() {
      var cd = document.querySelector('cart-drawer');
      if (!cd || cd.__cqNudgeObs || !window.MutationObserver) return;
      cd.__cqNudgeObs = true;
      new MutationObserver(function (muts) {
        var real = muts.some(function (m) {
          return [].some.call(m.addedNodes, function (n) { return n.nodeType === 1 && !(n.classList && (n.classList.contains('cq-nudge') || n.classList.contains('cq-xmas'))); });
        });
        if (!real) return;
        clearTimeout(nudgeTimer);
        nudgeTimer = setTimeout(function () { nudgeSync(); xmasCart(); }, 400);
      }).observe(cd, { childList: true, subtree: true });
    }

    // Black Friday bonus: every order placed during Black Friday gets a 20% Christmas code (sent on WhatsApp on 1 Dec,
    // valid until 25 Dec). Shown in the gifts box, under the Buy button on other product pages and in the cart drawer.
    var CQ_GIFT_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M20 7h-2.2A3 3 0 0 0 12 3.8 3 3 0 0 0 6.2 7H4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h.5v8a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-8h.5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm-5-2a1 1 0 1 1 0 2h-2V6a1 1 0 0 1 1-1h1zM9 5h1a1 1 0 0 1 1 1v1H9a1 1 0 1 1 0-2zM5 9h6v1H5V9zm1.5 3H11v7H6.5v-7zM13 19v-7h4.5v7H13zm6-9h-6V9h6v1z"/></svg>';
    function xmasOn() { return !!(window.cqBf && Date.now() <= window.cqBf.end); }
    function xmasHtml(cls) {
      return '<div class="' + cls + '"><span class="cq-xmas__icon">' + CQ_GIFT_SVG + '</span><span class="cq-xmas__txt">' +
        '<b>Bonus: 20% off for Christmas</b><small>Every Black Friday order gets a 20% code on WhatsApp on 1 Dec, valid until 25 Dec on orders over $60.</small></span></div>';
    }
    function xmasPdp() {
      if (!xmasOn() || document.querySelector('kaching-bundle.cq-tiers') || document.querySelector('.cq-xmas--pdp')) return;
      var btn = mainBuyBtn(), wrap = btn && btn.closest('.product__submit__buttons');
      if (!wrap || btn.disabled) return;
      var after = document.querySelector('.cq-eta-line') || wrap;
      after.insertAdjacentHTML('afterend', xmasHtml('cq-xmas cq-xmas--pdp'));
    }
    function xmasCart() {
      if (!xmasOn()) return;
      var foot = document.querySelector('cart-drawer .cart__foot__inner');
      if (!foot || foot.querySelector('.cq-xmas')) return;
      foot.insertAdjacentHTML('afterbegin', '<div class="cq-xmas cq-xmas--cart"><span class="cq-xmas__icon">' + CQ_GIFT_SVG + '</span><span class="cq-xmas__txt"><b>This order unlocks a 20% Christmas code</b><small>Sent on WhatsApp on 1 Dec, valid until 25 Dec on orders over $60.</small></span></div>');
    }

    function wideTiles() {
      // The full-width collection tile needs a bigger image than the theme's half-width default.
      document.querySelectorAll('.index-collections-list .collection-list > .collection-item:last-child:nth-child(odd) img').forEach(function (i) {
        i.sizes = '(min-width: 768px) calc(100vw - 64px), calc(100vw - 32px)';
      });
    }

    function soldOutLast() {
      // Sold-out watches go to the end of product grids and the homepage watch row.
      document.querySelectorAll('.cq-rail__track').forEach(function (t) {
        [].slice.call(t.children).forEach(function (c) { if (c.classList.contains('is-soldout') && !c.__cqLast) { c.__cqLast = 1; var all = t.querySelector(':scope > .cq-wr__all'); if (all) t.insertBefore(c, all); else t.appendChild(c); } });
      });
      document.querySelectorAll('grid-item.product-item .badge-box.sold-box').forEach(function (b) {
        var it = b.closest('grid-item.product-item'), p = it && it.parentElement;
        if (p && !it.__cqLast) { it.__cqLast = 1; p.appendChild(it); }
      });
    }

    function init() { initVideos(); footer(); trustLabels(); kachingWatch(); kachingPicker(); giftTiers(); watchCart(); giftWatch(); railsUpdate(); bfBadges(); bfBadgeWatch(); stickyBuy(); swapInit(); nudgeWatch(); xmasPdp(); xmasCart(); wideTiles(); soldOutLast(); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();


/* ---- Black Friday pre-orders: out-of-stock watches are sold as pre-orders that ship in 2-3 weeks ----
   Shows "PRE-ORDER" instead of "Save x%" / "Sold out" on cards, "Pre-order" on the product button,
   a "ships in 2-3 weeks" note on the product page and in the cart, and records it on the order. */
(function () {
  var PO = ['beirut-gold', 'beirut-golden-aura', 'silver-ember', 'oree-ring-watch', 'beirut-golden-aura-full-set', 'beirut-imperial-golden-aura'];
  var NOTE = 'Pre-order – ships in 2–3 weeks';
  function handleOf(href) { var m = (href || '').match(/\/products\/([^\/?#]+)/); return m ? m[1] : ''; }
  function isPO(href) { return PO.indexOf(handleOf(href)) > -1; }
  function setText(el, t) { if (el && el.textContent.trim() !== t) el.textContent = t; }

  var css = document.createElement('style');
  css.textContent =
    '.cq-po-tag{background:#141414!important;color:#fff!important;letter-spacing:.06em}' +
    '.cq-po-note{display:flex;align-items:center;gap:6px;margin:10px 0 0;font-size:13px;font-weight:600;color:#141414}' +
    '.cq-po-note:before{content:"";width:8px;height:8px;border-radius:50%;background:#C9A227;flex:0 0 8px}' +
    '.cq-po-line{display:block;margin-top:4px;font-size:12px;font-weight:600;color:#8a6d1a}';
  document.head.appendChild(css);

  function apply() {
    // Homepage watch row cards
    document.querySelectorAll('.cq-wr__card').forEach(function (c) {
      var a = c.querySelector('a[href*="/products/"]');
      if (!a || !isPO(a.getAttribute('href'))) return;
      c.classList.remove('is-soldout');
      var tag = c.querySelector('.cq-wr__tag');
      if (tag) { setText(tag, 'PRE-ORDER'); tag.classList.add('cq-po-tag'); tag.classList.remove('cq-wr__tag--sale'); }
      var pr = c.querySelector('.cq-wr__price');
      if (pr && /notify/i.test(pr.textContent)) setText(pr, 'Ships in 2–3 weeks');
    });
    // Collection / search grid cards
    document.querySelectorAll('.product-item').forEach(function (c) {
      var a = c.querySelector('a[href*="/products/"]');
      if (!a || !isPO(a.getAttribute('href'))) return;
      var badges = c.querySelectorAll('.badge-box');
      if (badges.length) {
        setText(badges[0], 'PRE-ORDER'); badges[0].classList.add('cq-po-tag');
        for (var i = 1; i < badges.length; i++) badges[i].style.display = 'none';
      } else {
        var box = c.querySelector('.badge-box-container');
        if (box) { var b = document.createElement('span'); b.className = 'badge-box cq-po-tag'; b.textContent = 'PRE-ORDER'; box.appendChild(b); }
      }
      var so = c.querySelector('.product-item__price .sold-out');
      if (so) setText(so, 'Pre-order');
    });
    // Product page
    if (isPO(location.pathname)) {
      document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
        if (f.closest('.cq-wr__card, .product-item, .cart-drawer, cart-drawer')) return;
        if (!f.querySelector('input[name="properties[Pre-order]"]')) {
          var inp = document.createElement('input');
          inp.type = 'hidden'; inp.name = 'properties[Pre-order]'; inp.value = 'Ships in 2–3 weeks';
          f.appendChild(inp);
        }
        var btn = f.querySelector('button[name="add"], button[type="submit"]');
        if (btn) {
          var lbl = btn.querySelector('[data-add-to-cart-text], span') || btn;
          if (/add to cart|sold out|buy|pre-order/i.test(lbl.textContent)) setText(lbl, 'Pre-order – Ships in 2–3 weeks');
        }
      });
    }
    // Product page buttons (main, sticky bar, cart bar): 'Notify me' / 'Sold out' / 'Add to cart' become 'Pre-order – Ships in 2–3 weeks'
    if (isPO(location.pathname)) {
      document.querySelectorAll('.product-soldout-notification button, .product__submit button, .cart-bar__submit button, .cq-sticky__btn, button[name="add"]').forEach(function (b) {
        if (b.name === 'subscribe' || b.closest('.cq-wr__card, .product-item, .cart-drawer, cart-drawer')) return;
        var leaf = b;
        b.querySelectorAll('span, div').forEach(function (e) { if (!e.children.length && /\S/.test(e.textContent) && leaf === b) leaf = e; });
        if (/notify|sold out|add to cart|pre-order$|^pre-order|buy/i.test(leaf.textContent.trim())) setText(leaf, 'Pre-order – Ships in 2–3 weeks');
      });
    }
    // Bundle bars: free gift packaging comes with every order, shown next to free shipping
    document.querySelectorAll('.kaching-bundles__free-gift__text').forEach(function (g) {
      if (/^free shipping$/i.test(g.textContent.trim())) setText(g, 'FREE Shipping & Gift Packaging');
    });
    // Cart drawer and cart page line items
    document.querySelectorAll('.cart-item, .cart__item, [data-cart-item], .cart-drawer__item, tr.cart__row, li.cart__item').forEach(function (row) {
      var a = row.querySelector('a[href*="/products/"]');
      if (!a || !isPO(a.getAttribute('href')) || row.querySelector('.cq-po-line')) return;
      var s = document.createElement('span'); s.className = 'cq-po-line'; s.textContent = NOTE;
      var title = row.querySelector('[class*="title"], [class*="name"]') || a;
      title.parentNode.insertBefore(s, title.nextSibling);
    });
    if (document.querySelector('.cart-item, .cart__item, [data-cart-item], .cart-drawer__item')) syncSoon();
  }

  // Record pre-order items on the order (cart attribute visible in the order admin)
  var lastSync = '';
  function syncCart() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var items = (cart.items || []).filter(function (it) { return PO.indexOf(it.handle) > -1; }).map(function (it) { return it.quantity + ' x ' + it.product_title; });
      var val = items.length ? items.join(', ') + ' – ships in 2–3 weeks' : '';
      var cur = (cart.attributes || {})['Pre-order'] || '';
      if (val === cur || val === lastSync) return;
      lastSync = val;
      fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Pre-order': val } }) });
    }).catch(function () {});
  }

  var st = null;
  function syncSoon() { clearTimeout(st); st = setTimeout(syncCart, 800); }
  var t = null;
  function schedule() { if (t) return; t = setTimeout(function () { t = null; apply(); }, 120); }
  // "Pre-order now" goes straight to checkout: once the item is added to the cart, open the checkout
  var poGo = 0;
  function goCheckout() {
    poGo = 0;
    try { sessionStorage.removeItem('cqPoGo'); } catch (e) {}
    var done = false;
    function go() { if (done) return; done = true; location.href = '/checkout'; }
    setTimeout(go, 2500);
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var items = (cart.items || []).filter(function (it) { return PO.indexOf(it.handle) > -1; }).map(function (it) { return it.quantity + ' x ' + it.product_title; });
      if (!items.length) return go();
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Pre-order': items.join(', ') + ' – ships in 2–3 weeks' } }) }).then(go, go);
    }).catch(go);
  }
  function poArmed() { return poGo && Date.now() - poGo < 20000; }
  function watchAdds() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button');
      if (b && /^pre-order/i.test(b.textContent.trim())) { poGo = Date.now(); try { sessionStorage.setItem('cqPoGo', String(poGo)); } catch (x) {} }
    }, true);
    var of = window.fetch;
    if (of) window.fetch = function (input) {
      var url = String((input && input.url) || input || '');
      var p = of.apply(this, arguments);
      if (/\/cart\/add/.test(url)) p.then(function (r) { if (r && r.ok && poArmed()) setTimeout(goCheckout, 100); }).catch(function () {});
      return p;
    };
    var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__cqUrl = String(u || ''); return oo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var x = this;
      if (/\/cart\/add/.test(x.__cqUrl || '')) x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300 && poArmed()) setTimeout(goCheckout, 100); });
      return os.apply(this, arguments);
    };
  }
  // If the add went through the normal cart page instead, continue to checkout from there
  if (/^\/cart\/?$/.test(location.pathname)) {
    var g = 0; try { g = +sessionStorage.getItem('cqPoGo') || 0; } catch (e) {}
    if (g && Date.now() - g < 30000) goCheckout();
  }

  function start() {
    apply(); syncCart();
    if (isPO(location.pathname)) watchAdds();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:updated', syncCart);
    document.addEventListener('theme:cart:change', syncCart);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
